<span class="switch" (click)="toggle()" [class.checked]="value">
  <small></small>
  <input type="checkbox" [id]="id" [name]="name" class="switch-control" [checked]="value" />
  <span class="switch-text">
    <span class="on">{{ onText }}</span>
    <span class="off">{{ offText }}</span>
  </span>
</span>
